import React, { useState, useEffect} from 'react'; 
import { useNavigate, useLocation } from 'react-router-dom';
import mainLogo from "../../assets/logo.png";
import './Theme.css';
import { SvgLock, SvgPowerOff } from "../SVG/svg";
import Background from "../../assets/ros_banner.png";
import { ExternalNonProdUrl, ExternalProdUrl, USERGROUP, useAuth, isUserOfType } from "../../provider/authprovider";
import { signOut, clearTokens, isTokenExpired, storeLoginUrlPath, getTokenDetails } from "../../utils/authflow";
import { checkUserType } from "../LandingPage/userApiCalls";

const ThemeHeader = () => {
    const headerBanner = { backgroundImage: `url(${Background})` }
    const { userDetails } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const tokenDetails = getTokenDetails();
    const [sysopsUser, setSysopsUser] = useState(false);

      useEffect(() => {
        const fetchData = async () => {
          await canManageApplication();
        };
    
        fetchData();
    
        if (isTokenExpired()) {
          storeLoginUrlPath(location.pathname);
          clearTokens();
          navigate('/');
        }
      }, []);

    

    const canManageApplication = async () => {
            try {
              const email = tokenDetails?.idToken?.claims?.email;
              const token = tokenDetails?.accessToken?.accessToken;
              const response = await checkUserType(email, token);
              setSysopsUser(response.recordfound);
            } catch (error) {
              console.error("Error checking email:", error);
            }
        
        return true;
      };

    return (
        <>
            <div className="header">
                <a data-testid="svg-logo" className="bh-logo" href="/" aria-label="Home" title="Home" rel="home">
                    <img className="bh-logo__image" src={mainLogo} alt="" />
                </a>
                <div className="header-right relative">
                    {/* <div className="div-search">
                        <input type="text" placeholder="Search" className="search-input" />
                    </div> */}
                    {userDetails.isLoggedIn &&
                        <div className="user-profile">
                            <div className="user-circle">{userDetails.icon}</div>
                            <ul>
                                <li className="user-pill">
                                    <div className="user-circle-large">{userDetails.icon}</div>
                                    <strong>{userDetails.name}</strong>
                                    <small>{userDetails.email}</small>
                                </li>
                                {/* <li className="li-search"><input type="text" placeholder="Search" className="search-input" /></li> */}
                                {
                                    isUserOfType(userDetails.userGroup,USERGROUP.PROD_EXTERNAL) &&
                                    <li data-testid="svg-menu" className="user-profile-option">
                                        <a href={ExternalProdUrl} target="_blank" rel="noreferrer">
                                            <SvgLock /><span>Change Password</span>
                                        </a>
                                    </li>
                                }
                                {
                                    isUserOfType(userDetails.userGroup,USERGROUP.NONPROD_EXTERNAL) &&
                                    <li className="user-profile-option">
                                        <a href={ExternalNonProdUrl} target="_blank" rel="noreferrer">
                                            <SvgLock /><span>Change Password</span>
                                        </a>
                                    </li>
                                }
                                { sysopsUser && (
                                <li className="user-profile-option">
                                    <a href="/manage-applications">
                                    <span>Manage Applications</span>
                                    </a>
                                </li>
                                )}
                                { sysopsUser && (
                                <li className="user-profile-option">
                                    <a href="/manage-users">
                                    <span>Manage Users</span>
                                    </a>
                                </li>
                                )}
                                {/* <li className="user-profile-option">
                                    <a href="#logout" onClick={signOut}><SvgPowerOff /><span>Log Out</span></a>
                                </li> */}
                            </ul>
                        </div>
                    }
                </div>
            </div>
            <div className="header-banner" style={headerBanner}>
                <div className="header-banner-text">
                    <h1>BEACON Services</h1>
                    <p className="header-subheader">Connecting you to your global network, anytime, anywhere. Access data, monitor performance, collaborate in real-time, and make faster decisions for peak efficiency and productivity.</p>
                </div>
            </div>
        </>
    )
}

export default ThemeHeader
